import React from 'react';
import { DatePicker } from 'antd';
import { AntdFormItem, AntdFormItemProps } from '@/components/AntdForm/AntdFormItem.tsx';
import { cn } from '@/utils/style.ts';
import dayjs, { Dayjs } from 'dayjs';

type DateStringPickerProps = Omit<React.ComponentProps<typeof DatePicker>, 'value' | 'onChange'> & {
  value?: string | null;
  onChange?: (val?: string | null) => void;
};

type AntdFormDateStringPickerProps = React.ComponentProps<typeof DatePicker> & {
  //
} & AntdFormItemProps;

const underlyingValueFormat = 'YYYY-MM-DD';

const DateStringPicker: React.FC<DateStringPickerProps> = ({ value, onChange, ...props }) => {
  const format = (props.format as string) || underlyingValueFormat;

  const handleChange = (value?: string) => {
    onChange?.(value ? value : undefined);
  };

  return (
    <DatePicker
      {...props}
      value={value ? dayjs(value, format) : undefined}
      onChange={(dayjsObj) => {
        if (dayjsObj) {
          handleChange((dayjsObj as Dayjs).format(format));
        } else {
          handleChange(undefined);
        }
      }}
      format={format}
      multiple={false}
    />
  );
};

export const AntdFormDatePicker: React.FC<AntdFormDateStringPickerProps> = ({
  fieldProps,
  className,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  value,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange,
  ...props
}) => {
  return (
    <AntdFormItem {...fieldProps}>
      <DateStringPicker {...props} className={cn('w-full', className)} />
    </AntdFormItem>
  );
};

export const AntdFormDayjsPicker: React.FC<AntdFormDateStringPickerProps> = ({
  fieldProps,
  className,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  value,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange,
  ...props
}) => {
  return (
    <AntdFormItem {...fieldProps}>
      <DatePicker {...props} className={cn('w-full', className)} />
    </AntdFormItem>
  );
};
